import get from 'lodash/get';
import getImageUrl from '@configuratorware/configurator-frontendgui/App/Utils/getImageUrl';

type OptionLike = {
  identifier?: string;
  detailImage?: string | null;
  thumbnail?: string | null;
};

export function buildDefaultDetailImagePath(identifier: string): string {
  return `/images/options/${identifier}_fullsize.webp`;
}

export function buildDefaultThumbnailPath(identifier: string): string {
  return `/images/options/${identifier}_thumbnail.webp`;
}

export function getOptionDetailImagePath(option: OptionLike | null | undefined): string | null {
  if (!option) return null;
  const direct = get(option, 'detailImage');
  return direct ? String(direct) : null;
}

export function resolveDetailImagePath(path: string | null | undefined): string | null {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return getImageUrl(path) || null;
}

export function resolveOptionDetailImageUrl(option: OptionLike | null | undefined): string | null {
  const path = getOptionDetailImagePath(option);
  if (path) return resolveDetailImagePath(path);
  if (option?.identifier) return resolveDetailImagePath(buildDefaultDetailImagePath(option.identifier));
  return null;
}

/** Small preview for the picker dialog. Falls back to the full image if no thumbnail exists. */
export function resolveOptionThumbnailUrl(option: OptionLike | null | undefined): string | null {
  const direct = get(option, 'thumbnail');
  if (direct) return resolveDetailImagePath(String(direct));
  if (option?.identifier) return resolveDetailImagePath(buildDefaultThumbnailPath(option.identifier));
  return null;
}

export function loadImageDimensions(url: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => reject(new Error(`Failed to load image: ${url}`));
    img.src = url;
  });
}
